import React from 'react';
const Footer = () => {
  return <footer className="bg-teal-900 text-white py-12 px-6 md:px-12" data-id="element-75">
      <div className="max-w-6xl mx-auto" data-id="element-76">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-77">
          <div className="flex items-center mb-6 md:mb-0" data-id="element-78">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j4ckz63hJh5X49fhFHKCGw/ChatGPT_Image_Jul_1__2025__05_41_29_PM-removebg-preview.png" alt="Neurotoned Logo" className="h-10 invert" data-id="element-79" />
            <span className="ml-2 text-xl font-semibold" data-id="element-80">Neurotoned</span>
          </div>
          <div className="flex space-x-6" data-id="element-81">
            <a href="#" className="hover:text-teal-300 transition duration-300" data-id="element-82">
              Terms
            </a>
            <a href="#" className="hover:text-teal-300 transition duration-300" data-id="element-83">
              Privacy
            </a>
            <a href="https://calendly.com/madisonstarr/30min" className="hover:text-teal-300 transition duration-300" data-id="element-84">
              Contact
            </a>
          </div>
        </div>
        <div className="text-center text-teal-300 text-sm" data-id="element-85">
          <p data-id="element-86">© {new Date().getFullYear()} Neurotoned. All rights reserved.</p>
          <p className="mt-2" data-id="element-87">
            Empowering therapists with trauma-informed, nervous system healing
            tools.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;